import {useMutation} from "@tanstack/react-query";

import {usersService} from "../../users/services";

export default function useChangePassword() {
  return useMutation({
    mutationFn: (data: {password: string}) => usersService.changePassword(data),
    retry: false,
  });
}
